// removed by extract-text-webpack-plugin
module.exports = {"Developer":"Developer__Developer__18l1G","Icon":"Developer__Icon__9x3F0","NoSkills":"Developer__NoSkills__1-nxH"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Developer/Developer.css
// module id = 141
// module chunks = 0